import React, { useState, forwardRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { drawerStore } from '../drawer/DrawerStore';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';
import { PERMISSIONS, hasPermission } from 'shared/security/rolePermissions';

const NAV_ITEMS = [
	{
		route: '/pipeline',
		icon: '/ats/icons/pipeline-icon.svg',
		label: 'Pipeline',
		permission: PERMISSIONS.ATS_NAV_PIPELINE
	},
	{
		route: '/candidates',
		icon: '/ats/icons/candidates-icon.svg',
		label: 'Candidates',
		permission: PERMISSIONS.ATS_NAV_CANDIDATES
	},
	{
		route: '/jobs',
		icon: '/ats/icons/jobs-icon.svg',
		label: 'Jobs',
		permission: PERMISSIONS.ATS_NAV_JOBS
	},
	{
		route: '/clients',
		icon: '/ats/icons/clients-icon.svg',
		label: 'Clients',
		permission: PERMISSIONS.ATS_NAV_CLIENTS
	},
	{
		route: '/external-applications',
		icon: '/ats/icons/applicants-icon.svg',
		label: 'External Applicants',
		permission: PERMISSIONS.ATS_NAV_EXTERNAL_APPLICATIONS
	},
	{
		route: '/settings',
		icon: '/ats/icons/settings-icon.svg',
		label: 'Settings',
		permission: PERMISSIONS.ATS_NAV_SETTINGS
	}
];

const SideNavigation = forwardRef(({ basePath }, ref) => {
	const [expanded, setExpanded] = useState(false);
	const menuItems = NAV_ITEMS.filter(item => hasPermission(item.permission));

	useEffect(() => {
		const dispose = reaction(
			() => ({
				isOpen: drawerStore.isOpen,
				drawerId: drawerStore.drawerId
			}),
			({ isOpen, drawerId }) => {
				const isProfileOpen =
					isOpen &&
					(drawerId === drawerStore.DRAWER_IDS.APPLICANT_PROFILE ||
						drawerId === drawerStore.DRAWER_IDS.JOB_POSITION_PROFILE ||
						drawerId === drawerStore.DRAWER_IDS.CLIENT_PROFILE ||
						drawerId === drawerStore.DRAWER_IDS.EXTERNAL_APPLICATION_PROFILE);

				if (isProfileOpen) {
					setExpanded(false);
				}
			}
		);

		return () => dispose();
	}, []);

	const renderMenuItem = (menuItem, index) => {
		const { route, icon, label } = menuItem;
		return (
			<NavLink
				key={index}
				to={`${basePath}${route}`}
				activeClassName="is-active"
				className={!expanded ? 'tooltip is-tooltip-right' : ''}
				data-tooltip={!expanded ? label : undefined}>
				<img alt={label} src={icon} />
				{expanded && <span>{label}</span>}
			</NavLink>
		);
	};

	return (
		<div
			className={`ats-sidebar ${expanded ? 'is-expanded' : 'is-collapsed'}`}
			ref={ref}
			style={{ width: expanded ? '214px' : '58px' }}>
			<div className="ats-sidebar-menu-list">
				<button
					className="back-btn button-bg-soft-small is-icon-only"
					onClick={() => {
						setExpanded(!expanded);
					}}>
					<img
						src={`/ats/icons/chevron-${expanded ? 'left' : 'right'}-icon.svg`}
						alt=""
					/>
				</button>
				{menuItems.map((menuItem, index) => renderMenuItem(menuItem, index))}
			</div>
		</div>
	);
});

export default observer(SideNavigation);
